const markDeclareReturn = [
    {
        "id": "return_1",
        "applicant": "楊小花",
        "operatorName": "楊小花",
        "reportYear": "2021",
        "reportMonth": "12",
        "createdOn": "2022-01-15T00:00:00.000+08",
        "crops": [
            {
                "cropName": "甘藍(高麗菜)",
                "actualPrintedQuantity": 500,
                "usageQuantity": 200,
                "loseQuantity": 50,
                "inventoryQuantity": 300,
                "profitAndLoseQuantity": 100,
                "applyNotPrinted": 100,
                "reportQuantity": 1000,
                "overPrinted": 30,
                "inventoryLastMonth": 500,
                "totalUsage": 1000,
                "reportNotPrinted": 0
            },
            {
                "cropName": "包心白菜",
                "actualPrintedQuantity": 100,
                "usageQuantity": 50,
                "loseQuantity": 10,
                "inventoryQuantity": 100,
                "profitAndLoseQuantity": 40,
                "applyNotPrinted": 100,
                "reportQuantity": 1000,
                "overPrinted": 30,
                "inventoryLastMonth": 500,
                "totalUsage": 1000,
                "reportNotPrinted": 0
            },
            {
                "cropName": "結球萵苣",
                "actualPrintedQuantity": 200,
                "usageQuantity": 150,
                "loseQuantity": 30,
                "inventoryQuantity": 200,
                "profitAndLoseQuantity": 80,
                "applyNotPrinted": 100,
                "reportQuantity": 1000,
                "overPrinted": 30,
                "inventoryLastMonth": 500,
                "totalUsage": 1000,
                "reportNotPrinted": 0
            },
            {
                "cropName": "青江菜",
                "actualPrintedQuantity": 300,
                "usageQuantity": 200,
                "loseQuantity": 70,
                "inventoryQuantity": 300,
                "profitAndLoseQuantity": 100,
                "applyNotPrinted": 100,
                "reportQuantity": 1000,
                "overPrinted": 30,
                "inventoryLastMonth": 500,
                "totalUsage": 1000,
                "reportNotPrinted": 0
            }
        ],
    }
]

export default markDeclareReturn